<template>
  <div class="attendee-evaluation">
    <div v-if="isFetching" class="page-loader">
      <c-loader />
    </div>

    <div v-else-if="!isFetching && errorStatus">
      <ErrorPage :status="errorStatus" :text="errorMessage"/>
    </div>

      <validation-observer v-slot="{ invalid, valid, errors, ...rest }" ref="form" v-else>

        <form @submit.prevent="send">
          <evaluation-table-layout
            v-for="(evaluation, index) in evaluationQuestions"
            :title="evaluation.name"
            :description="evaluation.comments"
            :key="index"
            :data-evaluation-title="evaluation.elementNumber"
            :noContentPadding="true"
          >
            <div
              v-for="(question, questionIndex) in evaluation.evaluationQuestions"
              :key="evaluation.id"
              class="evaluation-item-outside"
            >
              <evaluation-item-layout :title="question.question_text" >
                <validation-provider :rules="question.answers.length ? 'required' : ''" v-slot="{errors}">
                  <c-radio-group
                    v-if="question.answer_layout === 'radio'"
                    :id="`evaluation.${question.elementNumber}.value`"
                    :data-evaluation-index="question.elementNumber"
                    :name="`evaluation.${question.elementNumber}.value`"
                    label-key="name"
                    label-value="value"
                    v-model="question.value"
                    :options="question.answers"
                    :error="errors[0]"
                    :mediaQuery="[{media: 468, cols: 1},{media: 768, cols: 3},{media: 1000, cols: 4}, {media: 1100, cols: 5}]"
                  />

                  <c-textarea
                    v-if="question.answer_layout === 'textarea'"
                    :id="`evaluation.${question.elementNumber}.value`"
                    :data-evaluation-index="question.elementNumber"
                    :name="`evaluation.${question.elementNumber}.value`"
                    label=""
                    rows="6"
                    v-model="question.value"
                    :error="errors[0]"
                  />

                  <c-checkbox-group
                    v-if="question.answer_layout === 'checkbox'"
                    :id="`evaluation.${question.elementNumber}.value`"
                    :data-evaluation-index="question.elementNumber"
                    :name="`evaluation.${question.elementNumber}.value`"
                    label-key="name"
                    label-value="value"
                    v-model="question.value"
                    :options="question.answers"
                    :error="errors[0]"
                    checked-key="checked"
                    :mediaQuery="[{media: 468, cols: 1}]"
                  />
                </validation-provider>
              </evaluation-item-layout>
            </div>
          </evaluation-table-layout>

          <evaluation-table-layout
            v-if="type === 'session'"
            title="Attendance Attestation"
            description=""
          >
            <p>
              I am requesting <strong>{{ attendeeEvaluation.creditHours }}</strong> CE credits for <strong>{{ attendeeEvaluation.title }}</strong> and attest
              that I have been present for the entire session.<br />
              <strong>{{ attendeeEvaluation.attendeeName }}</strong><br />
              {{ currentDate }}<br />
              By Clicking "Submit", you are certifying that the above statement is true and correct to the best of your knowledge.
            </p>
          </evaluation-table-layout>

          <Notify theme="danger" v-if="submitError" class="evaluation-submit-error">
            {{ submitError }}
          </Notify>

          <div class="evaluation-footer">
            <c-button
              uppercase
              fill
              icon="fa-solid fa-paper-plane"
              type="submit"
              :show-indicator="showIndicator"
              theme="primary"
              size="sm"
            >Submit Your Response</c-button>
          </div>

        </form>
      </validation-observer>

  </div>
</template>

<script>
import Notify from "../ui/Notify";
import EvaluationItemLayout from "./evaluation-item-layout";
import EvaluationTableLayout from "./evaluation-table-layout";
import ErrorPage from "../../views/error-page";

export default {
  props: [
    'type',
    'evaluationQuestions',
    'showIndicator',
    'attendeeEvaluation',
    'isFetching',
    'errorStatus',
    'errorMessage',
    'submitError'
  ],
  components: {
    Notify,
    EvaluationTableLayout,
    EvaluationItemLayout,
    ErrorPage,
  },
  data() {
    return {}
  },
  computed: {
    currentDate() {
      const d = new Date();
      // "Tuesday"
      const weekday = d.toLocaleDateString("en-US", { weekday: "long" });
      // "July"
      const month   = d.toLocaleDateString("en-US", { month:   "long" });
      const day     = d.getDate();      // number of month
      const year    = d.getFullYear();  // number of year
      const suffix  = this.getOrdinalSuffix(day);

      return `${weekday}, ${month} ${day}${suffix} ${year}`;
    },
  },
  methods: {
    send() {
      this.$emit('submit', this.evaluationQuestions)
    },

    getOrdinalSuffix(n) {
      const j = n % 10,
        k = n % 100;
      if (j === 1 && k !== 11) return "st";
      if (j === 2 && k !== 12) return "nd";
      if (j === 3 && k !== 13) return "rd";
      return "th";
    },
  }
}
</script>

<style lang="scss">

.evaluation-item-outside{

  &:last-child{
    .evaluation-item{
      border-bottom: none;
    }
    //border-bottom: none;
  }
}
.attendee-evaluation {
  margin-top: var(--attendee-gap-md);

  // TODO CHECK IF EVERYTHING FINE HERE
  .app-radio, .app-checkbox {
    width: 100%;
  }

  .app-radio{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .radio-group {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr  !important;


    @media (max-width: 900px) {
      grid-column-gap: 10px !important;
    }

    @media (max-width: 640px) {
      grid-column-gap: 3px !important;

      label{
        div{
          font-size: 11px;
        }
      }
    }

    >div {
      min-width: 1px;
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }

  .app-radio {
    grid-template-columns: auto;
    justify-items: center;
  }
}

//html {
//  body {
//
//  }
//}

.evaluation-submit-error {
  margin: 10px 0;
}

.evaluation-footer{
  text-align: right;
}
</style>
